/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Directive, Input, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Directive({
    selector: '[ngfCollapsedPills]',
    standalone: false
})
export class CollapsedPillsDirective {

  @Input()
  set ngfCollapsedPills(value: number) {
    this.count.next(value >= 0 ? value : 0);
  }

  constructor(public readonly templateRef: TemplateRef<any>) {}

  private readonly count = new BehaviorSubject<number>(0);
  readonly count$ = this.count.pipe(distinctUntilChanged());
}
